import { cn } from "@/lib/utils";

export const subTabPillTrackClass =
  "inline-flex items-center gap-1 rounded-full bg-white p-1";

export const subTabPillClass = (active: boolean) =>
  cn(
    "inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-all",
    active
      ? "bg-primary text-primary-foreground shadow-sm"
      : "text-[#6B7280] hover:text-[#374151]",
  );
